import { THEME } from 'src/config/config'

type VendorUserLike =
  | {
      external_id?: string | null
      attributes?: {
        external_id?: string | null
      } | null
    }
  | null
  | undefined

type SolutionWithVendorUsers =
  | {
      vendor?: {
        users?: VendorUserLike[] | null
      } | null
      attributes?: {
        vendor?: {
          data?: {
            attributes?: {
              users?:
                | VendorUserLike[]
                | {
                    data?: VendorUserLike[] | null
                  }
                | null
            } | null
          } | null
        } | null
      } | null
    }
  | null
  | undefined

function extractExternalIds(users: VendorUserLike[] | null | undefined): string[] {
  if (!users?.length) return []
  return users
    .map((user) => user?.external_id ?? user?.attributes?.external_id ?? null)
    .filter((id): id is string => !!id)
}

export function canViewPaywalledSolutionFields(
  authIsPremium: boolean,
  solution: SolutionWithVendorUsers,
  viewerExternalUserId: string | undefined,
): boolean {
  if (authIsPremium) return true
  if (THEME !== 'legaltech') return false
  if (!viewerExternalUserId) return false

  const directUsers = solution?.vendor?.users
  const nestedUsersRaw = solution?.attributes?.vendor?.data?.attributes?.users
  const nestedUsers = Array.isArray(nestedUsersRaw) ? nestedUsersRaw : nestedUsersRaw?.data

  const allowedIds = [...extractExternalIds(directUsers), ...extractExternalIds(nestedUsers)]
  if (!allowedIds.length) return false
  return allowedIds.includes(viewerExternalUserId)
}
